import api from '../library/axios';
import RSA from '../library/rsa-encrypt';

export default {
  getList(page, search, sort_column, sort_type) {
    return api({
      method: 'get',
      url: '/api/users',
      params: {
        page,
        search,
        sort_column,
        sort_type,
      },
    });
  },
  createUser({
    name,
    phone_number,
    email,
    password,
    is_pic = false,
  }) {
    return api({
      method: 'post',
      url: '/api/users',
      data: {
        name,
        phone_number,
        email,
        password: RSA.encrypt(password, 'base64'),
        is_pic,
      },
    });
  },
  update(user_id, {
    name,
    email,
    is_pic,
    password,
    phone_number,
  }) {
    return api({
      method: 'patch',
      url: `/api/users/${user_id}`,
      data: {
        name,
        email,
        is_pic,
        password,
        phone_number,
      },
    });
  },
  delete(user_id) {
    return api({
      method: 'delete',
      url: `/api/users/${user_id}`,
    });
  },
  getLogActivities(page, search) {
    return api({
      method: 'get',
      url: '/api/users/log',
      params: {
        page,
        search,
      },
    });
  },
  connectAIDashboard({
    workspace_id,
    company_id,
    user_id,
  }) {
    return api({
      method: 'post',
      url: `api/sso/user-activate/${user_id}/ai-dashboard/`,
      data: {
        workspace_id,
        company_id,
      },
    });
  },
};
